import { render, staticRenderFns } from "./AddChainModal.vue?vue&type=template&id=bd3fec20&scoped=true&"
import script from "./AddChainModal.vue?vue&type=script&lang=ts&"
export * from "./AddChainModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd3fec20",
  null
  
)

export default component.exports